import { MiDetailFields } from "@miplatform/components";
import { SECTION_HEADER_VARIANTS } from "@miplatform/constants";
import { useEdit } from "@miplatform/hooks";
import { IHome } from "@miplatform/types";
import { mdiHomeVariantOutline } from "@mdi/js";

export const AddressDetailFields = ({ home }: AddressDetailFieldsProps) => {
  const detailFields = [
    {
      label: "Address Line 1",
      name: "address.addressLine1",
      width: "50%",
      readOnly: true,
    },
    {
      label: "Address Line 2",
      name: "address.addressLine2",
      width: "50%",
      readOnly: true,
    },
    {
      label: "City",
      name: "address.city",
      width: "50%",
      readOnly: true,
    },
    {
      label: "Zipcode",
      name: "address.postalCode",
      width: "50%",
      readOnly: true,
    },
    {
      label: "County",
      name: "address.county",
      width: "50%",
      readOnly: true,
    },
    {
      label: "State",
      name: "address.regionCode",
      width: "50%",
      readOnly: true,
    },
    {
      label: "Latitude",
      name: "address.location.latitude",
      width: "50%",
      readOnly: true,
    },
    {
      label: "Longitude",
      name: "address.location.longitude",
      width: "50%",
      readOnly: true,
    },
    {
      label: "Community Latitude",
      name: "communityLocation.Latitude",
      width: "50%",
      readOnly: true,
    },
    {
      label: "Community Longitude",
      name: "communityLocation.Longitude",
      width: "50%",
      readOnly: true,
    },
  ];

  const edit = useEdit(home);

  return (
    <MiDetailFields
      headerProps={{
        title: "Address",
        icon: mdiHomeVariantOutline,
        variant: SECTION_HEADER_VARIANTS.UNDERLINED,
      }}
      detailFields={detailFields}
      edit={edit}
    />
  );
};

interface AddressDetailFieldsProps {
  home: IHome;
}
